// import { ArrowRightIcon } from "@heroicons/react/24/outline"
import AOS from "aos"
import React, { useEffect } from "react"
import Blur1 from "../../components/Blur1"
import ContentBody from "../../components/ContentBody"
import Image from "../../components/Image"
import LFooter from "../../components/LinkLoomFooter"
import TallyForm from "../../components/TallyForm"

const IndexPage = () => {
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <div className="bg-black">
      <div>
        <ContentBody>
          <div className="relative isolate">
            <Blur1 />
            <div>
              <div className="mx-auto pt-12 lg:pt-24 mb-6 lg:mb-12">
                <div className="">
                  <h1 className="text-4xl font-medium leading-tight xl:leading-tight text-white sm:text-6xl lg:text-7xl">
                    Snag Early Access to LinkLoom iOS Beta
                  </h1>

                  <p className="mt-6 text-lg md:text-2xl text-slate-400">
                    Summarise Informative Articles & News into Tiny Facts &
                    Stats
                  </p>
                  <div className="flex flex-row items-center justify-between">
                    <div className="shrink-0 m-12">
                      <a href="/linkloom">
                        <div className="mx-auto zoom-in w-36 neon-glow animated-box">
                          <Image
                            alt="LinkLoom App Icon"
                            className="mx-auto"
                            data-aos="fade-up"
                            file="link-loom-engraved.png"
                          />
                        </div>
                      </a>
                    </div>
                    <div
                      className="grow flex flex-col items-center justify-center p-6 gap-2 border-2 border-purple-400 border-opacity-10 rounded-2xl bg-purple-400 bg-opacity-10 backdrop-blur-md shadow"
                      data-aos="fade-left"
                    >
                      <div
                        style={{
                          width: "200px",
                        }}
                      >
                        <Image
                          alt="LinkLoom App Store Wishlist"
                          className="mx-auto cursor-pointer h-12"
                          file="app-store-badge-black.png"
                        />
                      </div>
                      <div className="w-max text-white font-light tracking-wider text-xs bg-red-600 px-4 py-1 rounded-md">
                        Coming Soon!
                      </div>
                    </div>
                  </div>
                  <p className="mt-6 text-lg md:text-2xl text-slate-400">
                    Join our waitlist and be among the first to sprinkle a
                    little magic into your daily browsing routine 🌈.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ContentBody>

        <ContentBody>
          <div
            className="relative isolate z-10 overflow-hidden bg-white border border-slate-200 p-6 sm:p-12 shadow-xl sm:rounded-3xl"
            data-aos="fade-left"
          >
            <svg
              viewBox="0 0 1024 1024"
              className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
              aria-hidden="true"
            >
              <circle
                cx={512}
                cy={512}
                r={512}
                fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
                fillOpacity="0.7"
              />
              <defs>
                <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                  <stop stopColor="#7775D6" />
                  <stop offset={1} stopColor="#E935C1" />
                </radialGradient>
              </defs>
            </svg>
            <div className="mx-auto relative isolate bg-opacity-40 backdrop-blur-sm text-center lg:mx-0 lg:flex-auto lg:text-left">
              <Blur1 />
              <TallyForm
                link="https://tally.so/embed/3qB4ZO?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                title="App Store Wishlist for LinkLoom iOS App"
              />
            </div>
          </div>
        </ContentBody>
      </div>

      <LFooter
        title="Join Beta Wishlist - LinkLoom"
        description="Join the LinkLoom iOS App Beta Wishlist. Get bite-sized insights from your favorite articles with our app! Stay informed without the time commitment."
        url="linkloom/ios-wishlist"
        image="link-loom-ios.png"
        keywords="linkloom beta, link loom beta wishlist, link loom beta, summarize articles, summarize articles with ai, linkloom ios app, link loom ios app, linkloom, news bites, knowledge bites, create knowledge cards, create fact cards, create stat cards"
      />
    </div>
  )
}

export default IndexPage
